module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backtohome
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.opertionType !== 'add') ? [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.opertionType === 'edit'
    },
    on: {
      "click": _vm.editAPI
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.opertionType === 'edit'
    },
    on: {
      "click": _vm.delAPI
    }
  }, [_vm._v("删除")])] : _vm._e()], 2), _vm._v(" "), _c('el-form', {
    ref: "APIform",
    staticClass: "apigroups-body",
    class: {
      detailsform: _vm.opertionType === 'detail'
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.APIform,
      "label-width": "90px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 15,
      "lg": 13
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "接口组"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.detailData.GroupNO) + "." + _vm._s(_vm.detailData.GroupName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务ID",
      "prop": "ServerID"
    }
  }, [(_vm.opertionType === 'detail' || _vm.opertionType === 'edit') ? _c('span', [_vm._v(_vm._s(_vm.APIform.ServerID))]) : _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "服务ID",
      "maxlength": 60
    },
    model: {
      value: (_vm.APIform.ServerID),
      callback: function($$v) {
        _vm.$set(_vm.APIform, "ServerID", $$v)
      },
      expression: "APIform.ServerID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务描述",
      "prop": "AServerName"
    }
  }, [(_vm.opertionType === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.APIform.AServerName))]) : _c('el-input', {
    attrs: {
      "size": "small",
      "maxlength": 30,
      "placeholder": "服务描述"
    },
    model: {
      value: (_vm.APIform.AServerName),
      callback: function($$v) {
        _vm.$set(_vm.APIform, "AServerName", $$v)
      },
      expression: "APIform.AServerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务类型",
      "prop": "ServerType"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.APIform.ServerTypeID) + "." + _vm._s(_vm.APIform.ServerType))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接口名称",
      "prop": "InterfaceName"
    }
  }, [(_vm.opertionType === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.APIform.InterfaceName))]) : _c('el-input', {
    attrs: {
      "size": "small",
      "maxlength": 40,
      "placeholder": "接口名称"
    },
    model: {
      value: (_vm.APIform.InterfaceName),
      callback: function($$v) {
        _vm.$set(_vm.APIform, "InterfaceName", $$v)
      },
      expression: "APIform.InterfaceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接口状态",
      "prop": "Tag1"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.opertionType === 'detail'
    },
    model: {
      value: (_vm.APIform.Tag1),
      callback: function($$v) {
        _vm.$set(_vm.APIform, "Tag1", $$v)
      },
      expression: "APIform.Tag1"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("维护中")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接口描述",
      "prop": "Summary"
    }
  }, [(_vm.opertionType === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.APIform.Summary))]) : _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "接口描述",
      "maxlength": 1000
    },
    model: {
      value: (_vm.APIform.Summary),
      callback: function($$v) {
        _vm.$set(_vm.APIform, "Summary", $$v)
      },
      expression: "APIform.Summary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "apigroups-foot-btn"
  }, [(_vm.opertionType !== 'detail') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAPI
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.opertionType === 'edit') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2e9b52dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/00299303/apiServerDefinedAdd.vue
// module id = TfyU
// module chunks = 1